exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-title span{color:#e30613!important}", ""]);

// exports
